export const formatPhoneNumber = (phone, fallback = "---") => {
  if (!phone) return fallback;

  const cleaned = String(phone).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  return match ? `${match[1]}-${match[2]}-${match[3]}` : phone;
};
